import { render, staticRenderFns } from "./ShadowProjection.vue?vue&type=template&id=f97fed74"
import script from "./ShadowProjection.vue?vue&type=script&lang=js"
export * from "./ShadowProjection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports